import { get, set } from '@fingermarkglobal/cache';
import { validateTransactions } from '@fingermarkglobal/client-models';

const getTransactions = get(validateTransactions);
const setTransactions = set(validateTransactions);

export { getTransactions, setTransactions };